import {
  BannerSeverity,
  getCodedAnnotationPresentation,
  isCodedAnnotation,
} from 'services/webediErrors/annotationPresentation';
import { WebEDIAnnotation } from 'services/webediErrors/types';

export const getBannerSeverity = (annotation: WebEDIAnnotation): BannerSeverity => {
  return isCodedAnnotation(annotation) ? getCodedAnnotationPresentation(annotation).severity : 'error';
};

// WebEDIError carries an already-resolved title string; coded warnings/connector
// annotations don't, so we reuse the shared presentation title key (the same key
// the matching FieldAnnotationPopover preset renders). The discriminant tells the
// banner whether the value still needs translating.
export type BannerTitle = { kind: 'text'; value: string } | { kind: 'key'; value: string };

export const getBannerTitle = (annotation: WebEDIAnnotation): BannerTitle => {
  if (!isCodedAnnotation(annotation)) {
    return { kind: 'text', value: annotation.title };
  }
  return { kind: 'key', value: getCodedAnnotationPresentation(annotation).titleKey };
};
